import AppLayout from "@/layouts/app/AppLayout";
import DashboardView from '@/views/shared/dashboard/DashboardView.vue'

import MyEshowView from '@/views/shared/myeshow/MyEshowView.vue'
import ProductsView from '@/views/shared/products/ProductsView.vue'
import CompaniesView from '@/views/shared/companies/CompaniesView.vue'
import CompanyProfileView from '@/views/shared/companies/CompanyProfileView.vue'
import BuyersView from '@/views/shared/buyers/BuyersView.vue'
import CommunityView from '@/views/shared/community/CommunityView.vue'
import CommunityMemberView from '@/views/shared/community/CommunityMemberView.vue'
import SpeakersView from '@/views/shared/speakers/SpeakersView.vue'
import AgendaView from '@/views/shared/agenda/AgendaView.vue'
import AgendaSessionView from '@/views/shared/agenda/AgendaSessionView.vue'
import ServicesView from '@/views/shared/services/ServicesView.vue'
import HelpDeskView from '@/views/shared/support/HelpDeskView.vue'
import FoodShowOnDemandView from '@/views/shared/on-demand-video/FoodShowOnDemandView.vue'
import FoodShowOnDemandWatchView from '@/views/shared/on-demand-video/FoodShowOnDemandWatchView.vue'
import MessagesView from '@/views/shared/messages/MessagesView.vue'
import MyAccountView from '@/views/shared/account/MyAccountView.vue'





export default [


  {
    path: "/app",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      // Base roles for the /app area. `visitor` is intentionally NOT here: it is
      // whitelisted only on the dashboard + VOD children below, which declare
      // their own `roles` (child meta overrides parent). Every other child
      // inherits this list and therefore stays blocked for `visitor`.
      roles: ["exhibitor", "attendee", "sponsor", "speaker", "buyer"],
    },
    children: [
      {
        name: 'shared.dashboard',
        path: 'dashboard',
        component: DashboardView,
        meta: { roles: ["exhibitor", "attendee", "sponsor", "speaker", "buyer", "visitor", "admin"] }
      },
      {
        name: 'shared.my-eshow',
        path: 'my-eshow',
        component: MyEshowView
      },
      {
        name: 'shared.products',
        path: 'products',
        component: ProductsView
      },
      {
        path: 'companies',
        children: [
          {
            name: 'shared.companies',
            path: '',
            component: CompaniesView
          },
          {
            name: 'shared.company-profile',
            path: ':id',
            component: CompanyProfileView
          }
        ]
      },
      {
        name: 'shared.vib-buyers',
        path: 'buyers',
        component: BuyersView
      },
      {
        path: 'community',
        children: [
          {
            name: 'shared.community',
            path: '',
            component: CommunityView
          },
          {
            name: 'shared.community-member',
            path: ':id',
            component: CommunityMemberView
          }
        ]
      },
      {
        name: 'shared.speakers',
        path: 'speakers',
        component: SpeakersView
      },
      {
        name: 'shared.agenda',
        path: 'agenda',
        component: AgendaView
      },
      {
        name: 'shared.agenda-session',
        path: 'agenda/:id',
        component: AgendaSessionView
      },
      {
        name: 'shared.services',
        path: 'services',
        component: ServicesView
      },
      {
        name: 'shared.help-desk',
        path: 'help-desk',
        component: HelpDeskView
      },
      {
        name: 'shared.foodshow-on-demand',
        path: 'foodshow-on-demand',
        component: FoodShowOnDemandView,
        meta: { roles: ["exhibitor", "attendee", "sponsor", "speaker", "buyer", "visitor"] }
      },
      {
        name: 'shared.foodshow-on-demand.watch',
        path: 'foodshow-on-demand/:id',
        component: FoodShowOnDemandWatchView,
        meta: { roles: ["exhibitor", "attendee", "sponsor", "speaker", "buyer", "visitor"] }
      },
      {
        name: 'shared.messages',
        path: 'messages/:id?',
        component: MessagesView
      },
      {
        name: 'shared.my-account',
        path: 'my-account',
        component: MyAccountView
      }
    ],
  },
];
